import React from 'react';
import ServiceComponent from '../components/ServiceComponent';

const Service: React.FC = () => {
  return (
    <div>
      <ServiceComponent />
     </div>
  );
};

export default Service;